import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
  Button,
} from "@mui/material";
import ScrollBar from "../../../components/Scrollbar";
import { useMutation, useQuery } from "@apollo/client";
import Iconify from "../../../components/Iconify";
import {
  ACTIVAR_REGISTRO,
  DESACTIVAR_REGISTRO,
  OBTENER_PLAZAS,
} from "../../../graphql/plazas";
import FrmEditarPlaza from "./forms/FrmEditarPlaza";
const TABLE_HEAD = [
  { id: "plaza", label: "Nombre", alignRight: false },
  { id: "", label: "", alignRight: false },
];
const PlazaTabla = ({
  setOpenDialog,
  setBodyDialog,
  setErrorGraph,
  setOpenSnackBar,
}) => {
  const { data, loading, error } = useQuery(OBTENER_PLAZAS);
  const [desactivarPlaza] = useMutation(DESACTIVAR_REGISTRO, {
    update(cache, { data: { desactivarPlaza } }) {
      const { obtenerPlazas } = cache.readQuery({
        query: OBTENER_PLAZAS,
      });
      cache.writeQuery({
        query: OBTENER_PLAZAS,
        data: {
          obtenerPlazas: [...obtenerPlazas, desactivarPlaza],
        },
      });
    },
  });
  const [activarPlaza] = useMutation(ACTIVAR_REGISTRO, {
    update(cache, { data: { activarPlaza } }) {
      const { obtenerPlazas } = cache.readQuery({
        query: OBTENER_PLAZAS,
      });
      cache.writeQuery({
        query: OBTENER_PLAZAS,
        data: {
          obtenerPlazas: [...obtenerPlazas, activarPlaza],
        },
      });
    },
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  if (loading) {
    return <h1>cargando...</h1>;
  }
  const { obtenerPlazas } = data;
  //Longitud
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleActiveteRecord = async (e) => {
    try {
      const result = await activarPlaza({
        variables: {
          id: e,
        },
      });

      setOpenSnackBar(true);
      setErrorGraph({
        mensaje: result.data.activarPlaza,
        severity: "success",
      });

      console.log(result);
    } catch (error) {
      setOpenSnackBar(true);
      setErrorGraph({ mensaje: error.message, severity: "error" });
    }
  };

  const handleDeactivateRecord = async (e) => {
    try {
      const result = await desactivarPlaza({
        variables: {
          id: e,
        },
      });

      setOpenSnackBar(true);
      setErrorGraph({
        mensaje: result.data.desactivarPlaza,
        severity: "success",
      });
    } catch (error) {
      setOpenSnackBar(true);
      setErrorGraph({ mensaje: error.message, severity: "error" });
    }
  };
  const handleEditData = (e) => {
    setBodyDialog(
      <FrmEditarPlaza
        setOpenDialog={setOpenDialog}
        setErrorGraph={setErrorGraph}
        setOpenSnackBar={setOpenSnackBar}
        id={e}
      />
    );
    setOpenDialog(true);
  };
  return (
    <>
      <ScrollBar>
        <Table>
          <TableBody>
            {obtenerPlazas
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                const { id, nombre, activo } = row;
                return (
                  <TableRow hover key={id} tabIndex={-1}>
                    <TableCell>{nombre}</TableCell>

                    <TableCell>
                      <Button
                        value={id}
                        onClick={(e) => {
                          handleEditData(id);
                        }}
                        startIcon={<Iconify icon="eva:edit-2-outline" />}
                      >
                        Editar
                      </Button>
                      {!activo ? (
                        <Button
                          color="primary"
                          value={id}
                          startIcon={<Iconify icon="eva:checkmark-outline" />}
                          onClick={(e) => {
                            handleActiveteRecord(id);
                          }}
                        >
                          Activar
                        </Button>
                      ) : (
                        <Button
                          value={id}
                          onClick={(e) => {
                            handleDeactivateRecord(id);
                          }}
                          color="error"
                          startIcon={<Iconify icon="eva:close-outline" />}
                        >
                          Desactivar
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </ScrollBar>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        page={page}
        count={obtenerPlazas.length}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default PlazaTabla;
